function TitleSlide() {
    return (
        <section>
            <h1>Hello, World!</h1>
        </section>
    );
}

export default TitleSlide;
